import {Container} from "@bounce/shared/ui";
import NiceModal from "@ebay/nice-modal-react";
import {Button, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useResetAccount} from "apis/requests/backoffice/resetAccount";
import AreYouSureDialog from "@bounce/shared/consumer/bounce-ui/components/Dialogs/AreYouSureDialog";
import {useAccountId} from "contexts";
interface ResetAccountTabProps {
  onClose: () => void;
}

export const ResetAccountTab = ({onClose}: ResetAccountTabProps) => {
  const urlAccountId = useAccountId();
  const [accountId, setAccountId] = useState(urlAccountId || "");
  const {mutate: resetAccount, isPending} = useResetAccount();

  useEffect(() => {
    if (urlAccountId) {
      setAccountId(urlAccountId);
    }
  }, [urlAccountId]);

  const handleReset = () => {
    if (!accountId.trim()) return;

    NiceModal.show(AreYouSureDialog, {
      headerTextId: "Reset Account",
      contentTextId: `Are you sure you want to reset account ${accountId}? This action cannot be undone.`,
      confirmTextId: "Reset Account",
      onConfirm: () => {
        resetAccount(
          {
            accountId: accountId.trim(),
          },
          {
            onSuccess: () => {
              setAccountId("");
              onClose();
            },
          }
        );
      },
    });
  };

  return (
    <Container sx={{gap: 2}}>
      <TextField
        fullWidth
        label="Account ID"
        value={accountId}
        onChange={(e) => setAccountId(e.target.value)}
        size="small"
      />

      <Button
        variant="contained"
        color="error"
        onClick={handleReset}
        disabled={!accountId.trim() || isPending}
        sx={{alignSelf: "flex-start"}}
      >
        {isPending ? "Resetting..." : "Reset Account"}
      </Button>
    </Container>
  );
};

export default ResetAccountTab;
